import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import MuiDialogActions from '@material-ui/core/DialogActions';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import { Box, Grid } from '@mui/material';
import { useState } from 'react';
import { useQuery } from '@apollo/client';
import { GET_HISTORIAL_COLABORADOR_PAQUETES } from '../../../Querys/prestaciones/querys';
import { ColaboradorPaqueteBitacora } from '../../../interfaces/Prestaciones.interface';
import ColaboradorPaqueteHistorialTimelineRow from './ColaboradorPaqueteHistorialTimelineRow';
import { exportarHistorialColaboradorPaquete } from './ExcelHistorialColaboradorPaquete';
import SortAscIcon from '../../../assets/svg/icono-ordenar-asc.svg';
import SortDescIcon from '../../../assets/svg/icono-ordenar-desc.svg';
import '../../Collaborator/History/History.css';

interface Props {
  open: boolean;
  onClose: () => void;
  idColaborador: string;
  nombreColaborador?: string;
}

const ColaboradorPaqueteHistorialModal = ({ open, onClose, idColaborador, nombreColaborador = '' }: Props) => {
  const [orderDate, setOrderDate] = useState<'ASC' | 'DESC'>('DESC');

  const { data, loading, error } = useQuery(GET_HISTORIAL_COLABORADOR_PAQUETES, {
    variables: { idColaborador },
    skip: !open || !idColaborador,
    fetchPolicy: 'no-cache',
  });

  const events: ColaboradorPaqueteBitacora[] = data?.GET_HISTORIAL_COLABORADOR_PAQUETES ?? [];
  const sorted = orderDate === 'DESC' ? events : [...events].reverse();

  return (
    <Dialog
      aria-labelledby="colaborador-package-history-dialog"
      className="history-modal"
      open={open}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        <h2 id="form-dialog-title" className="text-center" style={{ marginTop: 20 }}>
          Historial de paquetes
        </h2>
        <h3 id="form-dialog-subtitle">{nombreColaborador}</h3>
        <span id="closemodalx" onClick={onClose}>
          <img alt="close" src="/assets/svg/CloseM.svg" />
        </span>
      </DialogTitle>

      <DialogContent>
        {loading && (
          <div style={{ display: 'flex', justifyContent: 'center', padding: 32 }}>
            <CircularProgress style={{ color: '#FABB00' }} />
          </div>
        )}
        {!loading && error && (
          <Alert severity="error" style={{ margin: '16px 0' }}>
            No se pudo cargar el historial. Intenta de nuevo más tarde.
          </Alert>
        )}
        {!loading && !error && events.length === 0 && (
          <Alert severity="info" style={{ margin: '16px 0' }}>
            No hay movimientos registrados para este colaborador.
          </Alert>
        )}
        {!loading && !error && events.length > 0 && (
          <Box id="timeline">
            <Grid container justifyContent="flex-end">
              <Grid item xs={4} md={3}>
                <p
                  onClick={() => setOrderDate(o => o === 'DESC' ? 'ASC' : 'DESC')}
                  className="order-field"
                >
                  Fecha{' '}
                  {orderDate === 'DESC'
                    ? <span><img alt="desc" src={SortDescIcon} /></span>
                    : <span><img alt="asc" src={SortAscIcon} /></span>
                  }
                </p>
              </Grid>
            </Grid>
            {sorted.map((event, idx) => (
              <ColaboradorPaqueteHistorialTimelineRow
                key={event.id}
                event={event}
                color={idx % 2 === 0 ? 'blue' : 'dark-blue'}
              />
            ))}
          </Box>
        )}
      </DialogContent>

      <MuiDialogActions>
        {events.length > 0 && (
          <button
            className="buttonSave"
            style={{ marginRight: 8 }}
            onClick={() => exportarHistorialColaboradorPaquete(events, nombreColaborador)}
          >
            Exportar Excel
          </button>
        )}
        <button className="btnCancel" onClick={onClose}>
          Cerrar
        </button>
      </MuiDialogActions>
    </Dialog>
  );
};

export default ColaboradorPaqueteHistorialModal;
